var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import "./questionnaireResponses";
import NavBar from "../../organisms/navBar/navBar";
import PageHeader from "../../organisms/pageHeader/pageHeader";
import TableCard from "../../molecules/table/table";
import LoadingOverlay from "../../atoms/loadingOverlay/loadingOverlay";
import { useDispatch, useSelector } from "react-redux";
import { getQuestionnaireHistory } from "../../../redux/actions/questionnaireHistoryActions";
import { getQuesAttemptDetails, makeQuesFieldReady, } from "../../../redux/actions/dashboard";
import { Status } from "../../../redux/constants/status";
/**
 * The Obligations Page
 * This will need to call all relevant APIs to get the values.
 */
function Questionnaire() {
    // ALL HOOKS MUST BE CALLED AT THE TOP - BEFORE ANY CONDITIONAL LOGIC
    var dispatch = useDispatch();
    var viewing_username = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_username; });
    var numberOfAttempts = useSelector(function (state) {
        return state.rootReducer.questionnaireHistoryReducer.numberOfAttempts;
    });
    var dates = useSelector(function (state) { return state.rootReducer.questionnaireHistoryReducer.completedDates; });
    var logged_in_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.logged_in_user_type; });
    var viewing_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_user_type; });
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    var questionnaireHistoryStatus = useSelector(function (state) { return state.rootReducer.questionnaireHistoryReducer.status; });
    // ALL useEffect HOOKS
    useEffect(function () {
        if (viewing_username) {
            // Dispatch the action when the component mounts
            dispatch(getQuestionnaireHistory(viewing_username));
            dispatch(getQuesAttemptDetails(viewing_username));
        }
    }, [dispatch, viewing_username]);
    useEffect(function () {
        // setSecondAttempt(quesAttemptDetails.second_attempt_ready);
    }, [quesAttemptDetails]);
    // NOW WE CAN DO CONDITIONAL LOGIC AND EARLY RETURNS
    if (!numberOfAttempts || !dates) {
        // If numberOfAttempts or dates are falsy, return null or a loading indicator
        return null; // or return <LoadingIndicator /> or any other suitable component
    }
    // Create a mutable copy of dates for modification
    var modifiedDates = __spreadArray([], dates, true);
    // The progression milestone questionnaire only exists for a jobseeker once
    // their adviser has enabled it at least once - an untouched existing user
    // (ready and completed both false/undefined) never gets a physical
    // submission for it, so their own history view continues to show exactly
    // today's two rows (Questionnaire 1, Questionnaire 2).
    var milestoneRelevant = !!(quesAttemptDetails.milestone_questionnaire_ready ||
        quesAttemptDetails.milestone_completed);
    // Display name shown for each logical row - the milestone attempt is
    // intentionally NOT numbered "Questionnaire 2", since it's skippable and
    // a jobseeker who skips it would otherwise see a confusing "1, 3" gap.
    // Questionnaire 2 always stays the final/last attempt a jobseeker does,
    // exactly as it was before this feature existed.
    var QUESTIONNAIRE_DISPLAY_NAME = {
        1: "Questionnaire 1",
        2: "Progression Milestone",
        3: "Questionnaire 2",
    };
    // Maps each logical row to the `/questionnaireResponses/:questionnaireNumber`
    // route param it should link to - kept distinct from the display name so
    // the milestone attempt gets its own "milestone" param instead of "2",
    // and the final attempt keeps using "2" exactly as it always has.
    var QUESTIONNAIRE_ROUTE_PARAM = {
        1: "1",
        2: "milestone",
        3: "2",
    };
    // Maps a logical questionnaire number (1/2/3) to its physical index into
    // `modifiedDates` (the jobseeker's actual chronological submissions).
    // Logical 2 (milestone) only occupies a physical slot when it's relevant;
    // otherwise logical 3 (the final attempt) is the 2nd submission.
    var physicalIndexForLogical = function (logical) {
        if (logical === 1)
            return 0;
        if (logical === 2)
            return milestoneRelevant ? 1 : -1;
        return milestoneRelevant ? 2 : 1; // logical === 3
    };
    var ques_attempts = {
        1: quesAttemptDetails.completed_once,
        2: quesAttemptDetails.milestone_completed,
        3: quesAttemptDetails.completed_twice,
    };
    var adviser_ques_attempts = {
        1: quesAttemptDetails.adv_questionnaire_one_complete,
        2: quesAttemptDetails.adv_milestone_questionnaire_complete &&
            quesAttemptDetails.milestone_questionnaire_ready,
        3: quesAttemptDetails.adv_questionnaire_two_complete &&
            quesAttemptDetails.second_attempt_ready,
    };
    var ques_attempts_enable = {
        2: quesAttemptDetails.milestone_questionnaire_ready,
        3: quesAttemptDetails.second_attempt_ready,
    };
    var adviser_ques_attempts_enable = {
        1: !quesAttemptDetails.adv_questionnaire_one_complete,
        2: quesAttemptDetails.adv_questionnaire_one_complete &&
            quesAttemptDetails.milestone_questionnaire_ready,
        3: quesAttemptDetails.adv_questionnaire_one_complete &&
            quesAttemptDetails.second_attempt_ready,
    };
    var toggleFieldForLogical = {
        2: "milestone_questionnaire_ready",
        3: "second_attempt_ready",
    };
    var handleToggleBtn = function (field, toggle) {
        dispatch(makeQuesFieldReady(quesAttemptDetails, toggle, field));
    };
    var isQuestionnaireLoading = questionnaireHistoryStatus === Status.Loading;
    // The adviser always sees all three conceptual rows (once the jobseeker
    // has started anything at all) so they can enable/disable the milestone
    // and final questionnaire independently. The jobseeker's own view only
    // shows rows for submissions that actually exist for them.
    var hasAnySubmission = numberOfAttempts > 0;
    var logicalNumbers = logged_in_user_type === "adviser" ? [1, 2, 3] : milestoneRelevant ? [1, 2, 3] : [1, 3];
    var data = [];
    for (var _i = 0, logicalNumbers_1 = logicalNumbers; _i < logicalNumbers_1.length; _i++) {
        var logical = logicalNumbers_1[_i];
        var currentQuestionnaire = QUESTIONNAIRE_DISPLAY_NAME[logical];
        var innerData = [currentQuestionnaire];
        var physicalIdx = physicalIndexForLogical(logical);
        if (logged_in_user_type === "adviser") {
            if (!hasAnySubmission) {
                continue;
            }
            // The milestone sits before the final questionnaire, so once that's
            // done (and the milestone never was) there's nothing left to enable.
            if (logical === 2 &&
                quesAttemptDetails.completed_twice &&
                !ques_attempts[2] &&
                !ques_attempts_enable[2]) {
                continue;
            }
            if (!ques_attempts[logical]) {
                if (logical === 2 || logical === 3) {
                    innerData.push({
                        text: ques_attempts_enable[logical]
                            ? "Disable ".concat(currentQuestionnaire)
                            : "Enable ".concat(currentQuestionnaire),
                        type: "toggle",
                        field: toggleFieldForLogical[logical],
                        classname: ques_attempts_enable[logical] ? "toggle-enabled" : "",
                    });
                }
            }
            else {
                innerData.push(modifiedDates[physicalIdx]);
            }
            if (adviser_ques_attempts[logical]) {
                innerData.push("Adviser ".concat(currentQuestionnaire, " Taken"));
                innerData.push({
                    link: "/questionnaireResponses/".concat(QUESTIONNAIRE_ROUTE_PARAM[logical]),
                    text: "View Results >",
                });
            }
            else {
                if (adviser_ques_attempts_enable[logical]) {
                    innerData.push({
                        link: "/questionnaire/adviserProgression",
                        text: "Take Adviser ".concat(currentQuestionnaire),
                        type: "button",
                    });
                }
            }
        }
        else {
            if (physicalIdx < 0 || physicalIdx >= modifiedDates.length) {
                continue;
            }
            innerData.push(modifiedDates[physicalIdx]);
            innerData.push({
                link: "/questionnaireResponses/".concat(QUESTIONNAIRE_ROUTE_PARAM[logical]),
                text: "View Results >",
            });
        }
        data.push(innerData);
    }
    var headers = logged_in_user_type === 'adviser'
        ? ["Attempts", "Date", "Questionnaire Status", ""]
        : ["Attempts", "Date", ""]; // Add an empty string for the last column
    // const data = dates.map((element: string, index: number) => [
    //   `Questionnaire ${index + 1}`,
    //   logged_in_user_type === "adviser" &&
    //     ques_attempts[`Questionnaire ${index + 1}`]
    //     ? element
    //     : logged_in_user_type === "adviser" ? {
    //       // handleClick: handleToggleBtn(!quesAttemptDetails.second_attempt_ready),
    //       text: ques_attempts_enable[`Questionnaire ${index + 1}`]
    //         ? "Disable Questionnaire 2"
    //         : "Enable Questionnaire 2",
    //       type: "toggle",
    //       classname: "set-btn-color",
    //     } : "",
    //   logged_in_user_type === "adviser" &&
    //     adviser_ques_attempts[`Questionnaire ${index + 1}`]
    //     ? `Adviser Questionnaire ${index + 1} Taken`
    //     : adviser_ques_attempts_enable[`Questionnaire ${index + 1}`]
    //       ? {
    //         link: "/questionnaire/adviserProgression",
    //         text: `Take Adviser Questionnaire ${index + 1}`,
    //         type: "button",
    //       }
    //       : "",
    //   element
    //     ? { link: `/questionnaireResponses/${index + 1}`, text: "View Results >" }
    //     : "",
    // ]);
    return (_jsxs("div", __assign({ className: "h-full" }, { children: [_jsx(NavBar, { viewing_user: viewing_user_type, logged_in_user: logged_in_user_type, viewing_username: viewing_username }), _jsxs("div", __assign({ className: "questionnaire-page-template-right", style: { position: "relative" } }, { children: [_jsx(LoadingOverlay, { isVisible: isQuestionnaireLoading, message: "Loading questionnaire history..." }), _jsx(PageHeader, { title: "Questionnaire History" }), _jsx(TableCard, { headers: headers, data: data, rowsPerPage: 10, handleClick: function (cell) {
                            return handleToggleBtn(cell.field, !quesAttemptDetails[cell.field]);
                        } })] }))] })));
}
export default Questionnaire;
